var _path, _path2, _circle, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1786 1.5H11.625V1.5C13.3954 1.5 14.7454 3.08429 14.4645 4.83224L13.4771 10.976C13.2433 12.4305 11.9882 13.5 10.5151 13.5H5.98493C4.51183 13.5 3.25668 12.4305 3.02293 10.976L2.03554 4.83224C1.75462 3.08428 3.10462 1.5 4.875 1.5V1.5H6.32143",
    stroke: "#998A7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06067 13.7647V18C8.06067 20.4853 10.0754 22.5 12.5607 22.5H14.9999C17.4852 22.5 19.4999 20.4853 19.4999 18V9",
    stroke: "#998A7B",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 7.5,
    r: 2.25,
    stroke: "#998A7B",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.28162,
    y: 0.356934,
    width: 2.13423,
    height: 2.25,
    rx: 1.06712,
    fill: "#998A7B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.10095,
    y: 0.356934,
    width: 2.13423,
    height: 2.25,
    rx: 1.06712,
    fill: "#998A7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.47cd3f827621e296b326d3461f67640e.svg";
export { ForwardRef as ReactComponent };